
const useShowQTXSurvey = (enableSurvey, childFrameData, matcher) => {
    let bswMatch = matcher || ".card.helptip.success";
    let bool2Rtn = false;
    console.info(`useShowQTXSurvey enableSurvey childFrameData matcher`, enableSurvey, childFrameData, matcher);
    if (enableSurvey) {
        const isValidChildFrameData = childFrameData.data && childFrameData.data.event && childFrameData.data.data ? true : false;
        if (isValidChildFrameData && childFrameData.data.event === "bswMatchedMutation" && childFrameData.data.data.type === "childList" && childFrameData.data.data.target === bswMatch) {
            bool2Rtn = true;//setShowQTXSurvey(true);

        }
    }
    console.info(`useShowQTXSurvey returning ${bool2Rtn}`);
    return bool2Rtn;
};
export default useShowQTXSurvey;